import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { prepareTenantFromUrl } from "utils/tenantHelper";
import { url, WEBSITE_DOMAIN } from "utils/constants";
import userService from "services/user.service";

import FormField from "components/FormField";
import Button, { SIZE } from "components/Button";

import background from "assets/images/login_background_blue.png";
import styles from "./Provider.module.scss";
import LogoDefault from "components/Logo";

const Provider = () => {
  const navigate = useNavigate();
  const [subdomain, setSubdomain] = useState("");
  const [error, setError] = useState("");
  const providerFromUrl = prepareTenantFromUrl(url);

  useEffect(() => {
    if (providerFromUrl) {
      navigate("/login");
    }
  }, [url, providerFromUrl, navigate]);

  const handleChange = (e) => {
    setError("");
    setSubdomain(e.target.value);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    userService.getSubdomain(subdomain).then(
      (response) => {
        // !!!!for master use this
        const subdomainUrl = `${url.split(".")[0]}.${subdomain}.${process.env.REACT_APP_WEBSITE_NAME}`;
        window.location.href = subdomainUrl.replace("https://.", "https://");

        // !!!!for dev use this
        // const subdomainUrl = `${subdomain}.${
        //   url.replace("https://", "").replace("www.", "").split(".")[0]
        // }.${process.env.REACT_APP_WEBSITE_NAME}`;
        // window.location.href = `https://${subdomainUrl}`;

      },
      (error) => {
        error.request.status === 404 &&
          setError("That doesn't look like a valid domain. Try again.");
      },
    );
  };

  return (
    <section className={styles.section}>
      <img src={background} alt="background" className={styles.background} />
      <LogoDefault className={styles.logo} />
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <form className={styles.form} action="submit" onSubmit={handleOnSubmit}>
            <FormField
              labelText="Enter you Domain to Login"
              value={subdomain}
              onChange={handleChange}
              className={styles.field}
              error={error}
              suffix={WEBSITE_DOMAIN}
            />
            {error && <p className={styles.error}>{error}</p>}
            <Button size={SIZE.MIDDLE} className={styles.button}>
              Continue
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Provider;
